import React from 'react';

interface PaginationControlsProps {
  page: number;
  perPage: number;
  total: number;
  totalPages: number;
  canNext: boolean;
  canPrev: boolean;
  startIndex: number;
  endIndex: number;
  onPageChange: (page: number) => void;
  onPerPageChange: (perPage: number) => void;
  compact?: boolean;
}

const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

const PaginationControls: React.FC<PaginationControlsProps> = ({
  page,
  perPage,
  total,
  totalPages,
  canNext,
  canPrev,
  startIndex,
  endIndex,
  onPageChange,
  onPerPageChange,
  compact = false,
}) => {
  if (total <= perPage && page === 1) return null;

  return (
    <div className={`flex flex-wrap items-center justify-between gap-3 border-t border-slate-100 px-4 py-3 text-xs ${compact ? 'mt-2' : 'mt-4'}`}>
      <div className="text-slate-500">
        顯示 <span className="font-semibold text-slate-700">{startIndex}-{endIndex}</span> / {total}
      </div>
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-1">
          <span className="text-slate-500">每頁</span>
          <select
            value={perPage}
            onChange={(e) => onPerPageChange(Number(e.target.value))}
            className="rounded-lg border border-slate-200 bg-white px-2 py-1 text-xs font-semibold text-slate-700 focus:border-brand-blue focus:ring-brand-blue"
          >
            {PAGE_SIZE_OPTIONS.map((opt) => (
              <option key={opt} value={opt}>
                {opt}
              </option>
            ))}
          </select>
        </div>
        <div className="flex items-center gap-1">
          <button
            type="button"
            onClick={() => canPrev && onPageChange(page - 1)}
            disabled={!canPrev}
            className="rounded-lg border border-slate-200 bg-white px-2 py-1 font-semibold text-slate-600 transition hover:bg-slate-50 disabled:opacity-40"
            aria-label="上一頁"
          >
            ←
          </button>
          <div className="flex items-center gap-1">
            <span className="rounded-md bg-slate-100 px-2 py-1 font-semibold text-slate-700">
              {page}
            </span>
            <span className="text-slate-400">/ {totalPages}</span>
          </div>
          <button
            type="button"
            onClick={() => canNext && onPageChange(page + 1)}
            disabled={!canNext}
            className="rounded-lg border border-slate-200 bg-white px-2 py-1 font-semibold text-slate-600 transition hover:bg-slate-50 disabled:opacity-40"
            aria-label="下一頁"
          >
            →
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaginationControls;
